import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { PrioTheme } from '../../../../../../theme/types';

interface Props {
  pdfUrl: string | null;
  pdfLoading: boolean;
  pdfLoadError: boolean;
  t: (key: string) => string;
  theme: PrioTheme;
  classes: {
    pdfPreview: string;
  };
}

export const InvoicePdfPreview: React.FC<Props> = ({
  pdfUrl,
  pdfLoading,
  pdfLoadError,
  t,
  theme,
  classes,
}) => {
  if (pdfLoading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: '300px',
          height: '100%',
          backgroundColor: theme.colors.application.background.light,
        }}
      >
        <span>{t('accounting:incomingInvoices.drawer.pdfLoading')}</span>
      </div>
    );
  }

  if (pdfUrl && !pdfLoadError) {
    // Fragment params try to hide default UI; some browsers may ignore.
    const viewerParams = '#toolbar=0&navpanes=0&scrollbar=0&zoom=page-width';
    const src = pdfUrl.includes('#') ? pdfUrl : `${pdfUrl}${viewerParams}`;

    return (
      <div
        className={classes.pdfPreview}
        style={{
          width: '100%',
          height: '100%',
          background: theme.colors.application.background.light,
          display: 'flex',
          alignItems: 'stretch',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        <embed
          src={src}
          type="application/pdf"
          style={{ width: '100%', height: '100%', border: 'none' }}
        />
      </div>
    );
  }

  if (!pdfLoading && pdfLoadError) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: '300px',
          height: '100%',
          backgroundColor: theme.colors.application.background.light,
        }}
      >
        <FontAwesomeIcon
          icon={['fal', 'file-slash']}
          style={{
            color: theme.colors.application.typography.default,
            fontSize: '24px',
          }}
        />
        <span style={{ marginLeft: theme.spacing.small }}>
          {t('accounting:incomingInvoices.drawer.noPdfAvailable')}
        </span>
      </div>
    );
  }

  return null;
};
